<template>
    <section class="products-all content-section">
        <b-container>
            <b-row>
                <b-col cols="12">
                    <h2 class="content-section-title">PRODUCT LIST</h2>
                </b-col>
                <b-col md="4">
                    <Aside :products="products" />
                </b-col>
                <b-col md="8" class="px-4">
                    <Product v-for="(product, index) in products" :key="index" :product="product" />
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>

<script>
import Aside from './_aside'
import Product from './_product'
import { productCategory } from '@/data'

export default {
    components: {
        Aside,
        Product
    },
    data() {
        return {
            products: productCategory
        }
    },
    methods: {
        getId (value) {
            return value.split(' ').map(v => v.toLowerCase()).join('-')
        }
    }
}
</script>

<style lang="scss">

</style>